import ListMap from '../core/ListMap';
import MetaField from './MetaField';

class MetaFieldList extends ListMap {
  constructor(args = {}) {
    const {
      data = [],
    } = args;

    super({ ...args, data: data.map(v => new MetaField({ ...args, data: v })) });

    // This must be called for every List implementation.
    this.list().map(v => v.parent(this));
  }

  constructItem(key) {
    return new MetaField({ data: { name: key } });
  }

  getListOrderedByOrdinal(metaOverrideSet) {
    let resourceTemplate = this;

    if (metaOverrideSet) {
      return resourceTemplate.list().map((metaField) => {
        return metaOverrideSet.applyOverrides(metaField);
      }).sort((a, b) => {
        let aValue = a.attr('ordinal');
        let bValue = b.attr('ordinal');

        if (aValue === undefined) {
          aValue = Infinity;
        }

        if (bValue === undefined) {
          bValue = Infinity;
        }

        if (aValue < bValue) return -1;
        if (aValue > bValue) return 1;
        return 0;
      });
    }

    return this.list();
  }
}

export default MetaFieldList;
